<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_orderxq">
          <!-- 面包屑 -->
          <div class="ttshop_ordernav clearfloat">
            <p class="ttshop_navtext" @click="goTtshop_user">个人中心</p>
            <span>&gt;</span>
            <p class="ttshop_navtext" @click="goTtshop_usermyorder">订单中心</p>
            <span>&gt;</span>
            <p class="ttshop_orderdh">订单：<strong>{{list.order_no}}</strong></p>
          </div>
          <!-- 待支付订单 -->
          <div class="ttshop_orderdzf clearfloat">
            <div class="ttshop_orderdzfleft">
              <h4 v-if="list.is_revoke == 1">已取消</h4>
              <template v-else-if="list.is_pay == 0">
                <template v-if="list.pay_type == 2">
                  <h4 v-if="list.is_send == 0 && list.is_revoke == 0">待发货</h4>
                  <h4 v-if="list.is_send == 1 && list.is_confirm == 0">待收货</h4>
                  <h4 v-if="list.is_confirm == 1">已收货</h4>
                  <h4 v-if="list.is_comment == 0 && list.is_confirm == 1">待评价</h4>
                </template>
                <h4 v-else>待付款</h4>
              </template>
              <h4 v-if="list.is_send == 0 && list.is_pay == 1 && list.is_revoke == 0">待发货</h4>
              <h4 v-if="list.is_send == 1 && list.is_confirm == 0">待收货</h4>
              <h4 v-if="list.is_confirm == 1">已收货</h4>
              <h4 v-if="list.is_comment == 0 && list.is_confirm == 1">待评价</h4>
              <p class="ttshop_orderlizf" v-show="list.is_pay == 0 && list.pay_type != 2 && list.is_revoke == 0" @click="payOrder(list.order_id,list.total_price)">立即支付</p>
              <!-- <p class="ttshop_orderdzftext">修改订单</p> -->
              <p class="ttshop_orderdzftext" v-show="!list.is_pay && list.is_revoke == 0 && list.pay_type != 2" @click="orderRevoke(list.order_id)">取消订单</p>
              <p class="ttshop_orderdzftext" v-show="list.is_pay && list.is_send==0 &&list.apply_delete!=1" @click="orderRevoke(list.order_id)">退款</p>
              <!-- <p class="ttshop_orderdzftext" v-show="list.is_send == 1 && list.is_confirm == 1 && list.is_comment == 0" @click="goEvaluate(list.order_id)">评价</p> -->
              <p class="ttshop_orderdzftext" v-show="list.is_send == 1 && list.is_confirm == 0" @click="confirm(list.order_id)">确认收货</p>
              <p class="ttshop_orderdzftext" v-show="list.is_send==0&&list.apply_delete==1 && list.is_revoke == 0">退款申请中</p>
              <p class="ttshop_orderdzftext" v-show="list.is_send==0 &&list.apply_delete==1 && list.is_revoke == 1">退款成功</p>
            </div>
            <div class="ttshop_orderdzfright">
              <ul class="clearfloat">
                <li class="active">
                  <h5>1</h5>
                  <p>拍下商品</p>
                  <span></span>
                </li>
                <li v-if="list.pay_type != 2"  :class="{active:list.is_pay == 1}">
                  <h5>2</h5>
                  <p>付款</p>
                  <span></span>
                </li>
                <li :class="{active:list.is_send == 1}">
                  <h5>3</h5>
                  <p>卖家发货</p>
                  <span></span>
                </li>
                <li :class="{active:list.is_confirm == 1}">
                  <h5>4</h5>
                  <p>确认收货</p>
                  <span></span>
                </li>
                <li :class="{active:list.is_comment == 1}">
                  <h5>5</h5>
                  <p>评价</p>
                  <span></span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 地址及物流信息 -->
          <div class="ttshop_orderdzwl clearfloat">
            <div class="ttshop_orderdzwleft">
              <h5>收货人信息</h5>
              <ul>
                <li class="clearfloat">
                  <p>收货人：</p>
                  <span>{{list.name}}</span>
                </li>
                <li class="clearfloat">
                  <p>收货地址：</p>
                  <span>{{list.address}}</span>
                </li>
                <li class="clearfloat">
                  <p>电话：</p>
                  <span>{{list.mobile}}</span>
                </li>
              </ul>
            </div>
            <div class="ttshop_orderdzwlright">
              <!-- 暂无物流订单信息显示 -->
              <div class="ttshop_orderdzwlzw" v-if="expressList==undefined">
                <h5>暂时没有订单信息</h5>
                <!-- <p>您的订单已签收。感谢您在京东购物，欢迎再次光临。参加评价还能赢取京豆哟。</p> -->
              </div>

              <div class="ttshop_orderdzwlxinxi" v-else>
                <ul>
                  <li class="clearfloat" v-for="(item, index) in expressList" :key="index">
                    <div class="ttshop_xinxitime">
                      {{item.datetime}}
                    </div>
                    <i></i>
                    <div class="ttshop_jieduan">
                      <h5>{{item.detail}}</h5>
                      <p>{{item.memo}}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 订单信息 -->
          <div class="ttshop_ordernews">
            <h4>订单信息</h4>
            <ul class="clearfloat">
              <li class="clearfloat">
                <p>订单编号：</p>
                <span>{{list.order_no}}</span>
              </li>
              <li class="clearfloat">
                <p>付款时间：</p>
                <span>{{list.addtime}}</span>
              </li>
              <li class="clearfloat">
                <p>应支付金额：</p>
                <span>￥{{list.pay_price}}</span>
              </li>
              <li class="clearfloat">
                <p>付款方式：</p>
                <span>在线支付</span>
              </li>
              <li class="clearfloat">
                <p>商品总额：</p>
                <span>￥{{list.total_price}}</span>
              </li>
              <li class="clearfloat">
                <p>运费金额：</p>
                <span>￥{{list.express_price}}</span>
              </li>
            </ul>
          </div>
          <!-- 商品信息 -->
          <div class="ttshop_shopnews">
            <div class="ttshop_shopnewstitle clearfloat">
              <p class="ttshop_shopfirst">商品信息</p>
              <p class="ttshop_shopbh">商品编号</p>
              <p class="ttshop_shopmoney">单价（元）</p>
              <p class="ttshop_shopnumber">数量</p>
              <p class="ttshop_shopcz">操作</p>
            </div>
            <div class="ttshop_shopconter">
              <div class="ttshop_shoplist clearfloat" v-for="(item, index) in list.goods_list" :key="index">
                <div class="ttshop_shoplistfirst clearfloat">
                  <div class="ttshop_orderimg">
                    <img :src="item.goods_pic" alt="">
                  </div>
                  <div class="ttshop_ordertext">
                    <h5>{{item.name}}</h5>
                    <span v-for="(attr,ids) in item.attr" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
                  </div>
                </div>
                <div class="ttshop_shopbhs">
                  <p>4617736</p>
                </div>
                <div class="ttshop_shopmoneys">
                  <p>￥{{item.total_price}}</p>
                </div>
                <div class="ttshop_shopnumbers">
                  <p>{{item.num}}</p>
                </div>
                <div class="ttshop_shopczs d-flex justify-content-center">
                  <!-- <block wx:if="{{item.order_refund_enable == 1}}">
                    <navigator url="/pages/checkRefundType/checkRefundType?id={{item.order_detail_id}}" hover-class="none" class="btns" wx:if="{{item.is_order_refund == 0}}">申请售后</navigator>
                    <text wx:if="{{item.is_order_refund == 1}}">已申请售后</text>
                  </block> -->
                  <template v-if="item.order_refund_enable == 1">
                    <p class="ttshop_shopczsitem" v-if="item.is_order_refund == 0" @click="goBarter(item.order_detail_id)">申请售后</p>
                    <p v-if="item.is_order_refund == 1">已申请售后</p>
                  </template>

                </div>
              </div>
            </div>
            <div class="ttshop_shopbutton clearfloat">
              <div class="ttshop_shopbuttonright">
                <ul>
                  <li class="clearfloat">
                    <p>商品总额：</p>
                    <span>¥{{list.total_price}}</span>
                  </li>
                  <li class="clearfloat">
                    <p style="word-spacing:20px">运　　费：</p>
                    <span>¥{{list.express_price}}</span>
                  </li>
                  <li class="clearfloat">
                    <p>应付总额：</p>
                    <strong>¥{{list.pay_price}}</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ttshop_pay">
      <el-dialog title="" :visible.sync="shopVisible" :before-close="payContTypeChange">
        <div class="pay-title d-flex align-items-center justify-content-center">微信支付￥{{payNum}}</div>
        <div class="pay-qrcode d-flex align-items-center justify-content-center ">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import QRCode from "qrcodejs2";
let Base64 = require("js-base64").Base64;
import "./user.css";
export default {
  components: {
    Header,
    Userheader,
    Foot,
  },
  data() {
    return {
      id: this.$route.query.id,
      list: "",
      time: "",
      shopVisible: false,
      payNum: "",
      expressList: "",
    };
  },
  mounted() {
    this.orderDetail();
    this.expressDetail();
  },
  methods: {
    //去个人中心
    goTtshop_user() {
      this.$router.replace("/ttshop_user");
    },
    //去列表
    goTtshop_usermyorder() {
      this.$router.replace("/ttshop_usermyorder");
    },
    //去退换货
    goBarter(id){
      this.$router.replace({ path: "/ttshop_barter", query: { id: id } });
    },
    //获取数据
    orderDetail() {
      this.$api
        .orderDetail({
          order_id: this.id,
        })
        .then((res) => {
          console.log(res);
          this.list = res.data;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    // 物流信息
    expressDetail() {
      this.$api
        .expressDetail({
          order_id: this.id,
          type: "mall",
        })
        .then((res) => {
          console.log(res);
          this.expressList = res.data.list;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },

    //取消订单
    orderRevoke(id) {
      this.$confirm("确定取消订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api
            .orderRevoke({
              order_id: id,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
              this.orderDetail();
            })
            .catch((err) => {
              // console.log(err);
              this.$message({
                type: "success",
                message: err.msg,
                showClose: true,
                offset: 200,
                duration: 1000,
              });
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    // 支付二维码关闭
    payContTypeChange() {
      let that = this;
      that
        .$confirm("是否取消支付", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.shopVisible = false;
          clearInterval(this.time);
          this.orderDetail();
        })
        .catch(() => {
          console.log("取消");
        });
    },
    //支付
    payOrder(id, payNum) {
      let _this = this;
      this.payNum = payNum;
      _this.$api
        .orderPay({
          pay_type: "WECHAT_PAY",
          order_id: id,
        })
        .then((res) => {
          _this.shopVisible = true;
          // this.list = res.data
          _this.time = setInterval(() => {
            _this.orderStatus(res.res.order_no);
          }, 5000);
          let url = Base64.decode(res.res.code_url);
          setTimeout(function () {
            _this.qrcodeScan(url);
          }, 100);
        })
        .catch((err) => {
          // this.user = err;
        });
    },
    qrcodeScan(url) {
      this.$refs.qrcode.innerHTML = "";
      //生成二维码
      let qrcode = new QRCode("qrcode", {
        width: 150, // 二维码宽度
        height: 150, // 二维码高度
        text: url,
      });
    },
    //订单状态
    orderStatus(order) {
      if (this.shopVisible == false) {
        clearInterval(this.time);
      }
      this.$api
        .orderStatus({
          order_no: "order_" + order,
        })
        .then((res) => {
          if (res.code == 0) {
            clearInterval(this.time);
            this.$message({
              type: "success",
              message: res.msg,
              showClose: true,
              offset: 200,
              duration: 1000,
            });
            this.shopVisible = false;
            // this.$router.push("/ttshop_mybalance");
            this.orderDetail();
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_orderxq {
  width: 100%;
  .ttshop_ordernav {
    width: 100%;
    margin-bottom: 20px;
    .ttshop_navtext {
      float: left;
      cursor: pointer;
      font-size: 12px;
      color: #333;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      &:hover {
        color: #ff0e25;
      }
    }
    span {
      float: left;
      font-size: 12px;
      color: #333;
      margin: 0 5px;
    }
    .ttshop_orderdh {
      float: left;
      font-size: 12px;
      color: #333;
      strong {
        font-size: 12px;
        color: #333;
        font-weight: 400;
      }
    }
  }
  .ttshop_orderdzf {
    width: 100%;
    height: 200px;
    background: #fff;
    margin-bottom: 20px;
    .ttshop_orderdzfleft {
      float: left;
      width: 290px;
      height: 200px;
      background: #ff9010;
      padding: 32px;
      box-sizing: border-box;
      h4 {
        font-size: 20px;
        color: #fff;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        margin-bottom: 28px;
      }
      .ttshop_orderlizf {
        display: block;
        width: 72px;
        height: 24px;
        border-radius: 2px;
        background: #ffffff;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        cursor: pointer;
        margin: 0 auto 20px;
        &:hover {
          background: #ff0e25;
          color: #fff;
        }
      }
      .ttshop_orderdzftext {
        display: table;
        font-size: 12px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        margin: 0 auto 8px;
      }
    }
    .ttshop_orderdzfright {
      float: left;
      width: 900px;
      height: 200px;
      background: #fff;
      padding: 80px 30px;
      box-sizing: border-box;
      ul {
        li {
          width: 20%;
          float: left;
          position: relative;
          h5 {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: #ebebeb;
            text-align: center;
            line-height: 24px;
            font-size: 14px;
            color: #999;
            font-weight: 500;
            margin: 0 auto 13px;
            position: relative;
            z-index: 10;
          }
          p {
            font-size: 12px;
            color: #999;
            text-align: center;
            margin-bottom: 8px;
          }
          span {
            display: block;
            text-align: center;
            font-size: 12px;
            color: #999;
            height: 16px;
          }
          &.active::before {
            background: #ff9010;
          }
          &.active h5 {
            background: #ff9010;
            color: #fff;
          }
          &.active p {
            color: #ff9010;
          }
          &:first-child::before {
            width: 50%;
            left: 57%;
            top: 14%;
            transform: translateX(0%);
          }
          &::before {
            content: "";
            position: absolute;
            top: 14%;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            height: 2px;
            background: #ebebeb;
          }
        }
      }
    }
  }
  .ttshop_orderdzwl {
    width: 100%;
    height: 274px;
    background: #fff;
    margin-bottom: 20px;
    .ttshop_orderdzwleft {
      float: left;
      width: 346px;
      height: 274px;
      padding: 24px 40px 24px 20px;
      box-sizing: border-box;
      position: relative;
      &::before {
        content: "";
        width: 1px;
        height: 226px;
        background: #ebebeb;
        position: absolute;
        top: 24px;
        right: -1px;
      }
      h5 {
        font-size: 16px;
        color: #999;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 30px;
      }
      ul {
        li {
          width: 100%;
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          p {
            float: left;
            font-size: 12px;
            color: #666;
            width: 60px;
            text-align: right;
            margin-right: 16px;
            line-height: 18px;
          }
          span {
            float: left;
            max-width: 210px;
            font-size: 12px;
            color: #333;
            line-height: 18px;
          }
        }
      }
    }
    .ttshop_orderdzwlright {
      float: left;
      width: 843px;
      height: 274px;
      padding: 24px 35px;
      box-sizing: border-box;
      .ttshop_orderdzwlzw {
        width: 100%;
        padding-top: 90px;
        box-sizing: border-box;
        // display: none;
        h5 {
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 16px;
          font-weight: 500;
          margin-bottom: 12px;
        }
        p {
          font-size: 12px;
          color: #999;
          text-align: center;
          line-height: 18px;
          font-weight: 400;
        }
      }
      .ttshop_orderdzwlxinxi {
        width: 100%;
        height: 225px;
        overflow-y: scroll;
        ul {
          li {
            width: 100%;
            .ttshop_xinxitime {
              float: left;
              width: 150px;
              font-size: 12px;
              color: #333;
              font-weight: 400;
              line-height: 12px;
              margin-right: 16px;
              padding-top: 4px;
              box-sizing: border-box;
              text-align: right;
            }
            i {
              float: left;
              display: block;
              width: 20px;
              height: 20px;
              background: #cccccc;
              border-radius: 50%;
              margin-right: 16px;
              position: relative;
              z-index: 10;
            }
            .ttshop_jieduan {
              float: left;
              max-width: 510px;
              padding-top: 4px;
              padding-bottom: 24px;
              box-sizing: border-box;
              position: relative;
              h5 {
                font-size: 12px;
                color: #333;
                font-weight: 500;
                line-height: 12px;
                margin-bottom: 8px;
              }
              p {
                font-size: 12px;
                color: #999;
                line-height: 18px;
                font-weight: 400;
              }
              &::before {
                content: "";
                width: 1px;
                height: 100%;
                background: #cccccc;
                position: absolute;
                top: 0;
                left: -26px;
              }
            }
            &:last-child .ttshop_jieduan:before {
              display: none;
            }
          }
        }
      }
    }
  }
  .ttshop_ordernews {
    width: 100%;
    margin-bottom: 20px;
    background: #fff;
    padding: 32px;
    box-sizing: border-box;
    h4 {
      font-size: 16px;
      color: #999;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 20px;
    }
    ul {
      li {
        float: left;
        width: 32%;
        margin-right: 2%;
        &:nth-child(3n) {
          margin-right: 0;
        }
        p {
          float: left;
          font-size: 12px;
          color: #666;
          font-weight: 400;
          line-height: 24px;
          text-align: right;
          width: 80px;
          margin-right: 10px;
        }
        span {
          float: left;
          font-size: 12px;
          color: #333;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
  }
  .ttshop_shopnews {
    width: 100%;
    .ttshop_shopnewstitle {
      width: 100%;
      height: 40px;
      background: #fafafa;
      line-height: 40px;
      p {
        float: left;
        height: 40px;
        font-size: 12px;
        color: #666;
        text-align: center;
      }
      .ttshop_shopfirst {
        width: 35%;
        padding-left: 24px;
        box-sizing: border-box;
        text-align: left;
      }
      .ttshop_shopbh {
        width: 20%;
      }
      .ttshop_shopmoney {
        width: 15%;
      }
      .ttshop_shopnumber {
        width: 15%;
      }
      .ttshop_shopcz {
        width: 15%;
      }
    }
    .ttshop_shopconter {
      width: 100%;
      .ttshop_shoplist {
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;
        background: #fff;
        border-bottom: 1px solid #ebebeb;
        .ttshop_shoplistfirst {
          float: left;
          width: 35%;
          padding-left: 24px;
          box-sizing: border-box;
          .ttshop_orderimg {
            float: left;
            width: 60px;
            height: 60px;
            margin-right: 12px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .ttshop_ordertext {
            float: left;
            width: 295px;
            h5 {
              font-size: 12px;
              color: #333333;
              font-weight: 500;
              line-height: 18px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-bottom: 5px;
            }
            span {
              font-size: 12px;
              color: #999;
              margin-right: 5px;
              strong {
                font-weight: 400;
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
        .ttshop_shopbhs {
          float: left;
          width: 20%;
          padding: 0 10px;
          box-sizing: border-box;
          p {
            font-size: 12px;
            color: #666;
            text-align: center;
          }
        }
        .ttshop_shopmoneys {
          float: left;
          width: 15%;
          padding: 0 10px;
          box-sizing: border-box;
          p {
            font-size: 12px;
            color: #666;
            text-align: center;
          }
        }
        .ttshop_shopnumbers {
          float: left;
          width: 15%;
          padding: 0 10px;
          box-sizing: border-box;
          p {
            font-size: 12px;
            color: #666;
            text-align: center;
          }
        }
        .ttshop_shopczs {
          float: left;
          width: 15%;
          padding: 0 10px;
          box-sizing: border-box;
          .ttshop_shopczsitem{
            cursor: pointer;
            &:hover{
              color: #ff0e25;
            }
          }
        }
      }
    }
    .ttshop_shopbutton {
      width: 100%;
      padding: 28px 60px 37px 60px;
      box-sizing: border-box;
      background: #fff;
      .ttshop_shopbuttonright {
        float: right;
        ul {
          li {
            p {
              float: left;
              width: 80px;
              text-align: right;
              font-size: 12px;
              color: #666;
              line-height: 32px;
            }
            span {
              font-size: 12px;
              color: #666;
              line-height: 32px;
            }
            strong {
              font-size: 18px;
              color: #ff4300;
              line-height: 32px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
.ttshop_pay {
  .pay-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .pay-qrcode {
    width: 200px;
    height: 200px;
  }
}
.ttshop_orderdzf {
  .ttshop_orderdzwleft {
    float: left;
    width: 800px;
    height: 200px;
    padding: 24px 40px 24px 20px;
    box-sizing: border-box;
    position: relative;
    h5 {
      font-size: 16px;
      color: #999;
      font-weight: 500;
      line-height: 16px;
      margin-bottom: 30px;
    }
    ul {
      li {
        width: 100%;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        p {
          float: left;
          font-size: 12px;
          color: #666;
          width: 60px;
          text-align: right;
          margin-right: 16px;
          line-height: 18px;
        }
        span {
          float: left;
          max-width: 800px;
          font-size: 12px;
          color: #333;
          line-height: 18px;
        }
      }
    }
  }
}
</style>
